import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
const PlatformAdminApp = React.lazy(() => import('./platform-admin/PlatformAdminApp'));
const RootApp = process.env.REACT_APP_PLATFORM_ADMIN === 'true' ? PlatformAdminApp : App;

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <React.Suspense fallback={<p>読み込み中…</p>}>
      <RootApp />
    </React.Suspense>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
